
export default function Services() {
  const services = [
    {
      icon: 'ri-search-eye-line',
      title: 'Investigative Journalism',
      description: 'Deep-dive investigations that uncover truth and hold power accountable. Our team of experienced journalists delivers comprehensive, fact-based reporting.',
      mobileDescription: 'Deep investigations with fact-based reporting.'
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Press Release Distribution',
      description: 'Amplify your message through our network of 130+ news outlets. Professional distribution services that ensure your story reaches the right audience.',
      mobileDescription: 'Reach 130+ outlets with your story.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'PR Services',
      description: 'Strategic public relations support for businesses and organizations. From media relations to crisis management, we help you control your narrative.',
      mobileDescription: 'Strategic PR and media relations.'
    }
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-primary">What we do</h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            We deliver impactful, fact-based journalism and strategic public relations.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-none">
            <div className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
              {services.map((service) => (
                <div key={service.title} className="flex flex-col">
                  <div className="flex items-center justify-between">
                    <dt className="flex flex-auto flex-col">
                      <dt className="flex-none text-base font-semibold leading-7 text-primary">
                        <span className="mr-4 h-5 w-5 flex-none flex-auto flex-col">
                          <i className={service.icon} />
                        </span>
                        {service.title}
                      </dt>
                      <dd className="mt-4 flex-auto flex-none text-base leading-7 text-gray-600">
                        {service.description}
                      </dd>
                    </dt>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
